import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EmailValidator} from "../../../../model/email-validator";

@Component({
  selector: 'app-email-address',
  templateUrl: './email-address.component.html',
  styleUrls: ['./email-address.component.css']
})
export class EmailAddressComponent implements OnInit{
@Input() recipient: string;
@Input() index: number;
@Output() public finalAddressMail: EventEmitter<any>;
constructor() {
  this.finalAddressMail = new EventEmitter();
}
  ngOnInit(): void {
  }

  public isValidMail(mail: string): boolean {
    return EmailValidator.emailIsValid(mail);
  }

  public closeComponent(): void {
    this.finalAddressMail.emit({email: this.recipient, index: this.index});
  }
}
